import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';

import {
    ILinearBetslipMessagesProviderService,
    LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
} from '../../../../../../base/services/betslip-messages-provider.service';
import { AlertType } from '../../../../../alerts/models';

@Component({
    selector: 'bs-linear-odds-change-notification',
    template: '<bs-alert [message]="offerChanged" [type]="type" [title]="title"/>',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LinearOddsChangeNotificationComponent {
    @Input() isPlacementError?: boolean;

    private readonly betNotPlaced: string;

    readonly offerChanged: string;
    readonly type = AlertType.Information;

    constructor(@Inject(LINEAR_BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: ILinearBetslipMessagesProviderService) {
        const combinedMessages = messageProvider.getMessages();

        this.offerChanged = combinedMessages.betslip.common.GlobalToastMessage;
        this.betNotPlaced = combinedMessages.betslip.common.BetNotPlaced;
    }

    get title(): string | null {
        return this.isPlacementError ? this.betNotPlaced : null;
    }
}
